const state = {
  chatrooms: {
    content: [],
    count: 0,
  },
  chatrooms_with: {
    content: [],
    count: 0,
  },
  chatroom: {},
  chatmessages: {
    isLoading: false,
    totalElements: 0,
    data: [],
  },
  chatmessages_system: {
    isLoading: false,
    totalElements: 0,
    data: [],
  },
  chatroom_watch: {
    messageIdx: 0,
  },
  chatmessage_system: {},
  post_processing: {},
  tempNewMessages: [],
};

export default state;
